export default __webpack_public_path__ + "static/media/refresh.a6d57d4c.svg";